"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setContext = setContext;

var _tslib = require("tslib");

var _apolloLink = require("apollo-link");

function setContext(setter) {
  return new _apolloLink.ApolloLink(function (operation, forward) {
    var request = (0, _tslib.__rest)(operation, []);
    return new _apolloLink.Observable(function (observer) {
      var handle;
      Promise.resolve(request).then(function (req) {
        return setter(req, operation.getContext());
      }).then(operation.setContext).then(function () {
        handle = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer)
        });
      })["catch"](observer.error.bind(observer));
      return function () {
        if (handle) handle.unsubscribe();
      };
    });
  });
}